export default __webpack_public_path__ + "static/media/fb-logo.69dd1cea.svg";